// extracted by mini-css-extract-plugin
module.exports = {"root":"Style_root__3y_xw","content":"Style_content__1iaaH","titulo":"Style_titulo__2ytoD","descripcion":"Style_descripcion__2PffL","img":"Style_img__2DD5A"};